module.exports = __webpack_public_path__ + "static/tap-tracking-028eeca0ad2ad295fe5f0b0fd4eb0994.png";